@if (selectedPartList.length > 0) {
  <div
    class="flex items-center gap-2"
    [ngClass]="{ 'flex-row px-2 py-1': row(), 'flex-col py-2 px-1': !row() }"
  >
    <div
      class="relative flex items-center gap-2"
      [ngClass]="{
        'flex-col max-w-[160px] overflow-x-auto': row(),
        'flex-col max-h-[315px] overflow-y-auto': !row(),
      }"
    >
      @for (selectedPart of selectedPartList; track selectedPartList) {
        <div
          class="relative flex-none rounded-full overflow-hidden"
          [ngClass]="{
            'w-[36px] h-[36px]': row(),
            'w-[50px] h-[50px]': !row(),
          }"
        >
          @if (choicePartList.includes(selectedPart)) {
            <div
              class="absolute w-full h-full bg-black/60 flex justify-center items-center text-white z-[20]"
            >
              <div class="flex items-center justify-center text-white text-xl">
                <mat-icon [inline]="true">check</mat-icon>
              </div>
            </div>
          }
          @if (selectedPart.thumbnail) {
            <img
              class="absolute w-full h-full"
              src="{{ selectedPart.thumbnail }}"
              style="width: 100%; height: 100%; object-fit: cover"
              alt="Fab Image"
            />
          }

          <button
            class="relative"
            style="
              top: 0;
              left: 0;
              width: 100%;
              height: 100%;
              padding: 0;
              border-radius: 50%;
              overflow: hidden;
              z-index: 21;
            "
            (click)="onClickSelectedPart(selectedPart)"
          ></button>
        </div>
      }
    </div>

    <div class="flex flex-col gap-1" [ngClass]="{ 'w-full': !row(), 'h-full w-12': row() }">
      <button
        class="text-xs rounded bg-sky-600 text-white w-full py-1 disabled:bg-black/30 dark:disabled:bg-white/60"
        [disabled]="choicePartList.length == 0"
        (click)="onClickAddCart()"
      >
        Add
      </button>
      <button
        class="text-xs rounded bg-rose-600 text-white w-full py-1 disabled:bg-black/30 dark:disabled:bg-white/60"
        [disabled]="choicePartList.length == 0"
        (click)="onClickClear()"
      >
        Clear
      </button>
    </div>
  </div>
}
